export default __webpack_public_path__ + "static/media/check.8f1e4dd4.svg";